import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ReviewData } from "../../../models/ReviewData";

import "./styles.scss";

interface IReviewItemProps {
  review: ReviewData;
  canReply?: boolean;
  onReply?: (review: ReviewData) => void;
  replyButtonText?: string;
}

export const ReviewItem: React.FunctionComponent<IReviewItemProps> = ({
  review,
  canReply = false,
  onReply,
  replyButtonText = "Send Message",
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.recentReviews.${key}`);

  const formatDate = (date: Date | string) => {
    return dayjs(date).format("YYYY/MM/DD");
  };

  const renderStars = (rating?: number) => {
    if (!rating) return null;

    return (
      <div className="stars">
        {Array.from({ length: 5 }, (_, index) => (
          <span key={index} className={index < rating ? "star filled" : "star"}>
            ⭐️
          </span>
        ))}
      </div>
    );
  };

  const formatComment = (comment?: string) => {
    if (!comment) return "";

    // 如果可以回覆，顯示完整內容
    if (canReply) {
      return comment;
    }

    // 否則截斷顯示
    const lines = comment.split("\n");
    if (lines.length > 5) {
      return lines.slice(0, 5).join("\n") + "...";
    }
    return comment;
  };

  return (
    <div className="review-item">
      <div className="review-header">
        <div className="reviewer-info">
          <span className="reviewer-name">
            {review.reviewer_name || t("no_name")}
          </span>
          {renderStars(review.rating)}
        </div>
        <div className="review-date">{formatDate(review.review_date)}</div>
      </div>
      <div className={`review-content ${canReply ? "full-content" : ""}`}>
        {formatComment(review.comment)}
      </div>
      {canReply && (
        <div className="review-actions">
          {review.replied === 1 ? (
            <>
            <div className="test-line"/>
              <div className="review-reply">{review.review_reply}</div>
            </>
          ) : (
            onReply && (
              <button className="btn btn-blue" onClick={() => onReply(review)}>
                {replyButtonText}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewItem;
